import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "vertical-delimiter" }, null, -1)
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("p", null, "© Copyright 2009 - " + _toDisplayString(_ctx.currentYear) + " All Rights Reserved", 1),
    _hoisted_1,
    _createElementVNode("a", {
      href: _ctx.links.privacy_policy,
      rel: "noopener noreferrer",
      target: "_blank"
    }, "Privacy Policy", 8, _hoisted_2),
    _createElementVNode("a", {
      href: _ctx.links.privacy_form,
      rel: "noopener noreferrer",
      target: "_blank"
    }, "Privacy Form", 8, _hoisted_3)
  ]))
}